<template>
    <div class="text-center" style="margin: 20px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        min-width="400"
        max-height="300"
        max-width="450"
        @scroll="handler"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-badge 
              :content="messages > 10 ? '10+' : messages" 
              :value="messages" 
              color="green" 
              overlap 
          >
          <i 
              class="bi bi-bell-fill style-i" 
              v-bind="attrs" 
              v-on="on"
          >
          </i>
          </v-badge>
        </template>
  
        <v-card style="overflow-x: scroll;">
  
          <v-list-item>
          <v-list-item-content>
              <v-list-item-title style="font-size: 18px; font-weight: bold;">Notificações</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
  
          <v-divider></v-divider>
  
          <v-list>
              <v-list-item three-line class="card-item" v-for="(notification, index) in 
                  notifications" :key="index">
                  <v-list-item-content class="item-content">
                      <div >
                          <v-list-item-title style="margin-bottom: 4px;" @click="eventClick(notification.id, notification.link)">
                              <a :class="themeClass">{{ notification.title || 'Notificação' }}</a>
                              <span style="margin: 5px;">{{ new Date(notification.createAt).toLocaleDateString() }}</span>
                          </v-list-item-title>
                          <div class="d-flex" >
                              <div class="row"  style="margin: -6px -3px" @click="eventClick(notification.id, notification.link)">
                                  <div class="col-11 d-flex">
                                      <v-list-item-subtitle style="font-weight: bold;">{{ notification.description }}</v-list-item-subtitle>
                                      
                                  </div>
                              </div>
                          <button v-if="notification.view === 'Não'" @click="changeView(notification.id)">
                                      <i style="margin: 5px;" class="bi bi-circle"></i>
                                  </button>
                                  <button v-else>
                                      <i style="margin: 5px;" class="bi bi-check-circle"></i>
                                  </button>
                          </div>
                          
                      </div>
                      
                  </v-list-item-content>
              </v-list-item>
  
  
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </template>
  
  
  <script>
  import moment from 'moment';
  import Vue from "vue";
  //import io from 'socket.io-client'
  //import { notify } from "../../services/nativeNotificationService";
  export default {
      name: 'menuStatus',
      data: () => ({
          componentKey: 0,
          moment: moment,
          menu: false,
          messages: 0,
          statusFlow: [],
          objIcon: {
              icon: 'bi bi-dot',
              styleIcon: 'color: #1976d2; font-size: 35px; margin-left: -10px;',
          },
          req: null,
          notifications: [],
          view: null,
          aprov: null,
          page: 1,
          count: 0,
          p: null,
  
          showObs: false,
          motivo: null,
          userName: null,
          indexAprov: null
  
          //socket: io('http://localhost:3001')
      }),
  
      methods: {
  
          handler (el) {
  
              if ((el.target.scrollHeight-300) <= el.target.scrollTop) {
                  this.page += 1
              }
          },
  
  
          async eventClick(id, link) {
              // await this.viewNotification(id) // Caso você tenha essa lógica previamente
  
              if (link !== null) {
                  if (link.startsWith("http://") || link.startsWith("https://")) {
                      // Abrir navegação externa em nova aba
                      window.open(link, "_blank");
                  } else {
                      // Abrir navegação interna em nova aba
                      const fullUrl = this.$router.resolve(link).href; // Resolve a rota interna
                      window.open(fullUrl, "_blank");
                  }
  
                  this.menu = false;
              }
          },
  
          async changeView(id) {
              const notification = this.notifications.find(notification => notification.id === id)
              notification.view = "Sim";
              await Vue.prototype.$http.put(`/Entity/Alert`, notification)
              this.messages--
          },
  
          async getNotification(){
              const user = await this.$auth.getUserParams()
            //   console.log(user)
              this.userId = user.userId
  
              // value: this.userName, searchFields: 'user',
              let req = await Vue.prototype.$http.get(`/Entity/Alert/search-fields`, { params: { searchFields: "view,user", value: `Não,${this.userId}`, page: 1, limit: 10}});
            //   console.log('response >>>',req)
  
              this.notifications = []
  
              if(req?.data?.data != null){
                  this.notifications = this.notifications.concat(req.data.data.data)
  
                  this.messages = 0
  
                  this.notifications.map(async (resp) => {
  
                      console.log('resp >>>',resp)
  
                      if(resp?.userId == user.userId){
                          if(resp?.view == "Não"){
                              this.messages++
                          }
                      } else {
                          if(resp?.view == "Não") this.messages++
                      }
                  })
              }
  
            //   console.log(this.notifications)
  
  
          },
  
          startInterval() {
              // Executa a função a cada 2 minutos (120000 ms)
              this.intervalId = setInterval(() => {
                  this.getNotification(); // Exemplo de execução
              }, 600000);
          },
  
          stopInterval() {
              // Para o intervalo
              if (this.intervalId) {
                  clearInterval(this.intervalId);
                  this.intervalId = null;
              }
          },
          
      },
  
      computed: {
        themeClass() {
            return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
        },
      },
  
      watch: {
  
          async page(){
              await this.getNotification()
          }
      },
  
      async created(){
          await this.getNotification()
  /*
          this.socket.on('receiveNotification', async (notification) => {
              console.log('notification ', notification)
              await this.getNotification()
              let notification = this.notifications.filter(resp => resp.id === )
              if(lastNotification){
                  console.log(lastNotification)
                  notify(lastNotification)
  
                  this.$forceUpdate()
              }
          })*/
      },
  
      mounted() {
          this.startInterval(); // Inicia o intervalo ao montar o componente
      },
  
      beforeDestroy() {
          this.stopInterval(); // Limpa o intervalo ao desmontar o componente
      },
  
  }
  </script>
  
  
  <style scoped>
  .style-i {
      color: white;
      font-size: 22px;
  }
  /*
  .style-i:hover {
      color: white;
  }*/
  
  .item-content {
      border-bottom: 1px solid rgba(172, 168, 168, 0.719);
  }
  
  a {
      color: black;
      margin-left: 5px;
      color: black;
  }
  
  
  span {
      float: right;
      font-size: 10px;
  }
  .card-item{
      position: relative;
  }
  
  .card-item:hover {
      cursor: pointer;
      background-color: whitesmoke;
  }
  
  .btn-aprovar, .btn-enviar-obs {
      background-color: green;
      border-radius: 15px;
      padding: 6px;
      color: white;
      font-size: 12px;
      margin: 0px 8px;
  }
  
  .btn-aprovar:hover, .btn-enviar-obs:hover {
      background-color: white;
      border: 1px solid green;
      color: green;
  }
  
  .btn-reprovar, .btn-cancelar-obs {
      background-color: red;
      border-radius: 15px;
      padding: 6px;
      color: white;
      font-size: 12px;
      margin: 0px 8px;
  }
  
  .btn-reprovar:hover, .btn-cancelar-obs:hover {
      background-color: white;
      border: 1px solid red;
      color: red;
  }
  
  .obs-container {
      margin-top: 3px;
      border: 1px solid #c5c0c0;
      padding: 5px;
  }
  
  .span-enviado {
      position: absolute;
      right: 15px;
      bottom: 2px;
  }
  
  .v-list-item__content{
      padding: 0px;
      max-height: 75px;
  }

  .dark-theme {
      color: white;
    }
  
    .light-theme {
      color: #000;
    }
  
  </style>